

<template>
  <section class="section7" ref="sectionRef">
    <div class="section7-header" :class="{ 'animated slide-up delay-0': isVisible }">
      <h2 class="section-title">Nos Cibles</h2>
    </div>

    <div class="card-grid">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="card"
        :class="{
          'animated slide-up': isVisible,
          [`delay-${index}`]: isVisible
        }"
      >
        <p class="card-text">{{ item }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { useInView } from '@/composables/useInView.js'

export default {
  name: 'Section7View',
  setup() {
    const { isVisible, target: sectionRef } = useInView({
      threshold: 0.2
    })

    const items = [
      "Les institutions financières doivent accroître l'intérêt de leurs clients pour leurs services bancaires par Internet, par téléphone mobile et par guichet automatique.",
      "Les institutions financières doivent accroître l'intérêt de leurs clients pour leurs services bancaires par Internet, par téléphone mobile et par guichet automatique.",
      "Entreprises en ligne et plateforme de paiement pour attirer du trafic sur leur site.",
      "Les entreprises clientes pour gérer leur consommation interne et la vente de services de télécommunications pour des tiers."
    ]

    return { items, isVisible, sectionRef }
  }
}




</script>

<style scoped>
.section7 {
  padding: 4rem 2rem;
  background-color: #f7f9fb;
  text-align: center;
  font-family: 'Public Sans', sans-serif;
}

.section7-header {
  margin-bottom: 3rem;
}

.section-title {
  font-size: 2.4rem;
  color: #111827;
  font-weight: 700;
}

/* GRID */
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1900px;
  margin: 0 auto;
}

/* CARD STYLE */
.card {
  background: #f1f4f9;
  border-radius: 26px;
  padding: 2rem;
  min-height: 580px;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  border: none;
}

.card:hover {
  transform: translateY(-6px);
  box-shadow: 0 0 0 2px #fff, 0 0 20px 5px rgba(66, 153, 225, 0.5), 0 0 40px rgba(90, 72, 236, 0.2);
}

.card-text {
  color: #1f2937;
  line-height: 1.6;
}

/* Animations */
.animated {
  opacity: 0;
  transform: translateY(40px);
  animation-duration: 0.9s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.65, 0, 0.35, 1.5);
}

.slide-up {
  animation-name: slideUp;
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Delays */
.delay-0 { animation-delay: 0.3s; }
.delay-1 { animation-delay: 0.5s; }
.delay-2 { animation-delay: 0.7s; }
.delay-3 { animation-delay: 0.9s; }
.delay-4 { animation-delay: 1.1s; }

@media (min-width: 1440px) {
  .card {
    min-height: 660px;
    padding: 3rem 2.5rem;
    font-size: 26px;
  }

  .card-text {
    font-size: 26px;
    line-height: 1.7;
  }

  .section-title {
    font-size: 3rem;
  }
}

</style>

